/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_CURRENT_ZERO_URA_DISPLAY =
  'REFRESH_CURRENT_ZERO_URA_DISPLAY';
export const SET_SELECTED_CHIP_CSHCN_RATE_AUDIT =
  'SET_SELECTED_CHIP_CSHCN_RATE_AUDIT';
export const IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES =
  'IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES';
export const GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES =
  'GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES';
export const GET_CURRENT_ZERO_URA = 'GET_CURRENT_ZERO_URA';
export const REFRESH_CURRENT_ZERO_URA = 'REFRESH_CURRENT_ZERO_URA';
